import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { FALLBACK_PROFILE_PIC_URL } from '../../constants'
import * as Styles from './styles'

interface Props {
   name: string
   phoneNumber: string
   profilePicUrl: string | null | undefined
}

const UserDetails = (props: Props): React.ReactElement => {
   const { name, phoneNumber, profilePicUrl } = props

   const { theme } = useAppTheme()
   const themes = theme.iam.userDetails
   const t = useCustomT('iam:userDetails')

   const renderUserField = (label: string, value: string) => (
      <div className={Styles.fieldContainerStyles}>
         <div className={cn(Styles.labelStyles, themes.labelColor)}>
            {label}
         </div>
         <div className={cn(Styles.valueStyles, themes.valueColor)}>
            {value}
         </div>
      </div>
   )

   return (
      <div className={Styles.containerStyles}>
         <div
            className={cn(
               Styles.avatarSectionStyles,
               themes.avatarSectionBgColor,
               themes.avatarSectionBorderColor
            )}
         >
            <img
               className={Styles.avatarImageStyles}
               src={profilePicUrl || FALLBACK_PROFILE_PIC_URL}
            />
         </div>
         <div
            className={cn(
               Styles.detailsSectionStyles,
               themes.detailsSectionBgColor,
               themes.detailsSectionBorderColor
            )}
         >
            {renderUserField(t('name'), name)}
            <div className={cn(Styles.dividerStyles, themes.dividerColor)} />
            {renderUserField(t('phoneNumber'), phoneNumber)}
         </div>
      </div>
   )
}

export default observer(UserDetails)
